<template>
    <div class="column">
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Incharge</label>
            </div>
            <div class="field is-expanded remarks">
                <div class="field has-addons">
                    <p class="control">
                        <a class="button is-static">
                            <i class="fas fa-user-tie"></i>
                        </a>
                    </p>
                    <p class="control remarks">
                        <input class="input" type="text" v-model="incharge" :disabled="isLocked" readonly>
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Paid*</label>
            </div>
            <div class="field">
                <div class="field has-addons">
                    <p class="control">
                        <a class="button is-static">
                            <i class="fas fa-wallet"></i>
                        </a>
                    </p>
                    <p class="control remarks">
                        <input class="input" type="number" v-model="paidAmount" placeholder="Amount been paid." :disabled="isLocked">
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label"></label>
            </div>
            <div class="field">
                <div class="field has-addons">
                    <p class="control remarks">
                        <label class="checkbox">
                            <input type="checkbox" value="1" v-model="UsdCosts" :disabled="isLocked">
                            Costs in USD
                        </label>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:['car'],
        data () {
            return {

            }
        },
        computed: {
            isLocked() {
                return this.$store.getters.getProformaInvoiceLockedStatus
            },
            incharge: {
                get() {
                    return this.$store.getters.getProformaInvoice.incharge
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceFieldValue', { field: 'incharge', value: value})
                }
            },
            paidAmount: {
                get() {
                    return this.$store.getters.getProformaInvoice.paid_amount
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceFieldValue', { field: 'paid_amount', value: value})
                }
            },
            UsdCosts: {
                get() {
                    return this.$store.getters.getProformaInvoice.cost_in_usd
                },
                set(value) {
                    let costRate = value ? 1 : null
                    this.$store.dispatch('changeProformaInvoiceFieldValue', { field: 'cost_in_usd', value: costRate})
                    this.$store.dispatch('calculateProformaInvoice')
                }
            }
        }
    }
</script>

<style scoped>
    .field-label {
        flex-grow: 0;
    }
    .field-label .label {
        font-size: medium !important;
    }
    .remarks {
        width: 93%;
    }
    .label {
        white-space: nowrap;
        min-width: 100px;
    }
    .is-static {
        min-width: 50px;
    }
    .checkbox {
        font-size: small !important;
        white-space: nowrap;
    }
</style>



// WEBPACK FOOTER //
// src/components/Cars/Columns/ProformaInvoice/ProformaInvoiceInCharge.vue